import {
  Spacing,
  Text,
  Title,
} from '@vkontakte/vkui';

import { MobileAboutUs } from './MobileAboutUs';
import { MobileIntroContentContainerProps, PageProps } from './types';
import { MODE_OPTIONS } from '../../../../../components/HorizontalSlides/constants';
import { PageOption } from '../../../../../components/HorizontalSlides/types';
import { INTRO_PANELS_OPTIONS } from '../../../../../constants/AboutData';

const Page: React.FC<PageProps> = ({ title, text })=> {
  return (
    <div style={{ padding: '0 13px' }}>
      <Title level="2" style={{ fontWeight: 700 }}>
        {title}
      </Title>
      <Spacing size={12} />
      <Text style={{ fontSize: 15, color: 'var(--vkui--color_text_subhead)' }}>
        {text}
      </Text>
    </div>
  );
};

const MobileAboutUsContainer: React.FC<MobileIntroContentContainerProps> = ({ goToPrediction }) => {
  const pagesOptions = INTRO_PANELS_OPTIONS.map((data, index): PageOption => {
    return {
      page: <Page text={data.text} title={data.title}/>,
      button: {
        text: data.buttonText,
        mode: (index + 1) ===  INTRO_PANELS_OPTIONS.length ? MODE_OPTIONS.PRIMARY as 'primary' : MODE_OPTIONS.OUTLINE as 'outline',
        onClick: undefined,
      }
    };
  });


  pagesOptions[pagesOptions.length - 1].button.onClick = goToPrediction;
  return (
    <MobileAboutUs pagesOptions={pagesOptions}/>
  );
};

export default MobileAboutUsContainer;
